exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  margin-top: 30px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/XAMPP/xamppfiles/htdocs/estudos/angular2/animation-course/basic-project/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main